import { LabelValueModel } from './label-value.model';

export class TrainingInfoModel {
  // General Program Information
  public academicYear: LabelValueModel;
  public numberAccreditedPrograms: LabelValueModel;
  public lengthAccreditedTraining: LabelValueModel;
  public minNumberPriorYearsRequired: LabelValueModel;
  public offersGraduateYearOnePositions: LabelValueModel;
  public avgNumberProgramYearOneInterviews: LabelValueModel;
  public percentRequiringStepOneScore: LabelValueModel;
  public percentRequiringLevelOneScore: LabelValueModel;

  // Residents
  public totalActiveResidentsOrFellows: LabelValueModel;
  public avgResidentsOrFellows: LabelValueModel;
  public avgPercentFemales: LabelValueModel;
  public avgPercentInternationalGraduates: LabelValueModel;
  public avgPercentDO: LabelValueModel;

  // Faculty
  public avgFullTimePhysicians: LabelValueModel;
  public avgPartTimePhysicians: LabelValueModel;
  public avgPercentFemaleFullTimePhysician: LabelValueModel;
  public avgRatioFullTimeToResidentToFellow: LabelValueModel;

  // Resident Work Hours (PY1)
  public avgHoursOnDutyPerWeek: LabelValueModel;
  public avgMaxConsecutiveHoursOnDuty: LabelValueModel;
  public avgDaysOffPerWeek: LabelValueModel;

  // Work Environment And Compensation (PY1)
  public avgPercentTrainingInHospitalOutpatientClinics: LabelValueModel;
  public avgPercentTrainingInNonHospitalAmbulatoryCare: LabelValueModel;
  public avgResidentToFellowCompensation: LabelValueModel;
  public avgWeeksOfVacation: LabelValueModel;

  // Graduates Career Plans
  public graduatesDataYear: LabelValueModel;
  public graduatesCompletedTraining: LabelValueModel;
  public graduatesWithKnownPlans: LabelValueModel;
  public graduatesPursuingMoreTraining: LabelValueModel;
  public graduatesInPractice: LabelValueModel;
  public graduatesInGroupPractice: LabelValueModel;
  public graduatesPracticingSameSpecialty: LabelValueModel;
  public graduatesPracticingSameStateAsProgram: LabelValueModel;
  public graduatesPracticingNHSC: LabelValueModel;
  public graduatesEnteringAcademia: LabelValueModel;
  public graduatesInAcademiaFullTime: LabelValueModel;
  public graduatesPursuingMilitary: LabelValueModel;
  public graduatesPursuingNonClinicalResearch: LabelValueModel;
  public graduatesPursuingNonMedicalCareer: LabelValueModel;
  public graduatesUnemployed: LabelValueModel;
  public graduatesGradYear: LabelValueModel;

  public relatedTraining: string;

  // Icons
  public definingFeatures: [];

  constructor(values?: Partial<TrainingInfoModel>) {
    Object.assign(this, values);
  }

  get generalProgramInfoDataRows(): LabelValueModel[] {
    return [
      this.academicYear,
      this.numberAccreditedPrograms,
      this.lengthAccreditedTraining,
      this.minNumberPriorYearsRequired,
      this.offersGraduateYearOnePositions,
      this.avgNumberProgramYearOneInterviews,
      this.percentRequiringStepOneScore,
      this.percentRequiringLevelOneScore,
    ];
  }

  get residentDataRows(): LabelValueModel[] {
    return [
      this.totalActiveResidentsOrFellows,
      this.avgResidentsOrFellows,
      this.avgPercentFemales,
      this.avgPercentInternationalGraduates,
      this.avgPercentDO,
    ];
  }

  get facultyDataRows(): LabelValueModel[] {
    return [
      this.avgFullTimePhysicians,
      this.avgPartTimePhysicians,
      this.avgPercentFemaleFullTimePhysician,
      this.avgRatioFullTimeToResidentToFellow,
    ];
  }

  get residentWorkHoursDataRows(): LabelValueModel[] {
    return [
      this.avgHoursOnDutyPerWeek,
      this.avgMaxConsecutiveHoursOnDuty,
      this.avgDaysOffPerWeek,
    ];
  }

  get workEnvironmentCompensationDataRows(): LabelValueModel[] {
    return [
      this.avgPercentTrainingInHospitalOutpatientClinics,
      this.avgPercentTrainingInNonHospitalAmbulatoryCare,
      this.avgResidentToFellowCompensation,
      this.avgWeeksOfVacation,
    ];
  }

  get graduatesCareerPlansDataRows(): LabelValueModel[] {
    return [
      this.graduatesCompletedTraining,
      this.graduatesWithKnownPlans,
      this.graduatesPursuingMoreTraining,
      this.graduatesInPractice,
      this.graduatesInGroupPractice,
      this.graduatesPracticingSameSpecialty,
      this.graduatesPracticingSameStateAsProgram,
      this.graduatesPracticingNHSC,
      this.graduatesEnteringAcademia,
      this.graduatesInAcademiaFullTime,
      this.graduatesPursuingMilitary,
      this.graduatesPursuingNonClinicalResearch,
      this.graduatesPursuingNonMedicalCareer,
      this.graduatesUnemployed,
      this.graduatesGradYear,
    ];
  }

  public getSpecialtyTrainingModels(): LabelValueModel[] {
    return [
      new LabelValueModel({label: 'General Program Information', value: this.generalProgramInfoDataRows}),
      new LabelValueModel({label: 'Residents', value: this.residentDataRows}),
      new LabelValueModel({label: 'Faculty', value: this.facultyDataRows}),
      new LabelValueModel({label: 'Resident Work Hours (PY1)', value: this.residentWorkHoursDataRows}),
      new LabelValueModel({label: 'Work Environment And Compensation (PY1)', value: this.workEnvironmentCompensationDataRows}),
    ];
  }
}
